import { api } from '@/apis';
import { log, startCase } from '@/utils';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export function useAggregate(
  collection: string,
  pipeline: object[],
  enabled?: boolean,
  staleTime?: number,
  gcTime?: number,
) {
  const queryKey = [collection, 'aggregate', pipeline];
  const queryClient = useQueryClient();
  const query = useQuery<object[]>({
    queryKey,
    queryFn: ({ signal }) => {
      log('Read', startCase(collection), { pipeline });

      return api
        .post(`pipeline/${collection}`, { json: pipeline, signal })
        .json();
    },
    placeholderData: (previousData) => previousData ?? [],
    staleTime,
    gcTime,
    enabled: !!enabled,
  });

  return {
    query,
    cancel: () => queryClient.cancelQueries({ queryKey }),
  };
}
